import { PAGE_PATH_HOME } from '@bluheadless/ui-logic/src/constants'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useMenu } from '@bluheadless/ui-logic/src/hooks/menu/useMenu'
import { trimSlashes } from '@bluheadless/ui-logic/src/utils/url'
import { cx } from '@emotion/css'
import { useRouter } from 'next/router'
import { array, oneOfType, string } from 'prop-types'
import { useIntl } from 'react-intl'
import { ImageBackground } from '../../../particles/image'
import { BreadcrumbsStyled, ImageWrapper, InnerHeader, Root, Search } from './customer-care-header.styled'

const CustomerCareHeader = ({ className, breadcrumbsName }) => {
	const { formatMessage } = useIntl()

	const {
		customerCare: {
			customerCareNestedLayout: {
				image: { src: imageSrc, height: imageHeight, width: imageWidth },
				menuIdentifier,
				search: { enabled: searchEnabled },
			},
		},
	} = useConfig()
	const { menu: customerCareMenu } = useMenu({ code: menuIdentifier })
	const {
		query: { paths },
	} = useRouter()

	const findMenuItem = () => {
		const menuItem = customerCareMenu?.find(({ url }) => trimSlashes(url) === paths.join('/'))
		return menuItem?.title
	}

	const additionalBreadcrumbs = Array.isArray(breadcrumbsName)
		? breadcrumbsName.map(({ title, url }) => ({
				title: formatMessage({ id: title }) || null,
				url: url || null,
		  }))
		: {
				title: (breadcrumbsName && formatMessage({ id: breadcrumbsName })) || findMenuItem() || null,
		  }

	const breadcrumbsItems = [{ title: formatMessage({ id: 'breadcrumbs_home' }), url: PAGE_PATH_HOME }].concat(
		additionalBreadcrumbs
	)

	return (
		<Root className={cx('CustomerCareHeader-root', className)}>
			{imageSrc ? (
				<ImageWrapper>
					<ImageBackground
						src={imageSrc}
						originalHeight={imageHeight}
						originalWidth={imageWidth}
						style={{
							width: '100%',
							height: '100%',
						}}
					/>
				</ImageWrapper>
			) : null}
			<InnerHeader search={searchEnabled}>
				<BreadcrumbsStyled
					items={breadcrumbsItems}
					activeLinkProps={{ underline: 'none', color: 'white.main', variant: 'caption' }}
				/>
			</InnerHeader>
			{searchEnabled && <Search />}
		</Root>
	)
}

CustomerCareHeader.propTypes = {
	/**
	 * Class name for the root element.
	 */
	className: string,
	/**
	 * Breadcrumbs name.
	 */
	breadcrumbsName: oneOfType([string, array]),
}

export default CustomerCareHeader
